import React from "react";

const Button = React.memo(function Button({
  children,
  onClick,
  className = "",
  secondary = false,
  disabled = false,
  type = "button",
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`btn ${secondary ? "btn-secondary" : "btn-primary"} ${className}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
});

export default Button;
